import SearchBar from './SearchBar'
import PageTitle from './PageTitle'
import Card from './Card'
import TabHeader from './TabHeader'
import TabBody from './TabBody'
import FormRow from './FormRow'
import Counter from './Counter'
import MyFiles from './Files'
import Modal from './Modal'
import ReprintModal from './ReprintModal'
import TextField from './TextField'
import Select from './Select'
import Textarea from './Textarea'
import Checkbox from './Checkbox'
import Switch from './Switch'
import Radio from './Radio'
import RowTitle from './RowTitle'
import RowText from './RowText'
import DeleteText from './DeleteText'
import SearchRow from './SearchRow'
import DatePicker from './DatePicker'
import ImgFile from './ImgFile'
import SearchFilter from './SearchFilter'
import BySlider from './BySlider'
import DateTimePicker from './DateTimePicker'
import DateTimeRangePicker from './DateTimeRangePicker'
import SortCheckboxTable from './SortCheckboxTable'
import CheckoutModal from './CheckoutModal'
import ChartTable from './ChartTable'
import InsideModal from './InsideModal'
import ReserveModal from './ReserveModal'
import AnnouncementDisplayModal from '@/components/AnnouncementDisplayModal'
import NewSwitch from '@/components/NewSwitch'
import ValidManagerCodeModal from '@/components/ValidManagerCodeModal.vue'
import NewCheckBox from '@/components/NewCheckBox'
import MyItemStockModal from '@/components/ItemStockModal.vue'
import SearchTextInput from '@/components/SearchTextInput.vue'
import LabelSelect from '@/components/LabelSelect.vue'
import LabelTextField from '@/components/LabelTextField.vue'
import CashDrawerRecordModal from '@/components/CashDrawerRecordModal.vue'
import MaintenanceModal from '@/components/MaintenanceModal.vue'
import NetworkDisconnectModal from '@/components/NetworkDisconnectModal.vue'
import AutoCompleteSelect from '@/components/AutoCompleteSelect.vue'
import QuantityCounter from '@/components/QuantityCounter.vue'
import LoadingOverLay from '@/components/LoadingOverLay.vue'
import InlineLoadingStatus from '@/components/InlineLoadingStatus.vue'

const components = [
	SearchBar,
	PageTitle,
	Card,
	TabHeader,
	TabBody,
	FormRow,
	Counter,
	MyFiles,
	Modal,
	ReprintModal,
	TextField,
	Select,
	Textarea,
	Checkbox,
	Switch,
	Radio,
	RowTitle,
	RowText,
	DeleteText,
	SearchRow,
	DatePicker,
	ImgFile,
	SearchFilter,
	BySlider,
	DateTimePicker,
	DateTimeRangePicker,
	SortCheckboxTable,
	CheckoutModal,
	ChartTable,
	InsideModal,
	ReserveModal,
	AnnouncementDisplayModal,
	NewSwitch,
	ValidManagerCodeModal,
	MyItemStockModal,
	NewCheckBox,
	SearchTextInput,
	LabelSelect,
	LabelTextField,
	CashDrawerRecordModal,
	MaintenanceModal,
	AutoCompleteSelect,
	QuantityCounter,
	NetworkDisconnectModal,
	LoadingOverLay,
	InlineLoadingStatus,
]

export default Vue => {
	components.forEach(e => {
		Vue.component(e.name, e)
	})
}
